import { STATUS_COLORS, type StatusVariant } from '../lib/statusColors';

interface AlertProps {
  variant: StatusVariant;
  children: React.ReactNode;
}

export const Alert: React.FC<AlertProps> = (props) => {
  const { variant, children } = props;
  const { bg, fg } = STATUS_COLORS[variant];

  return (
    <div
      style={{
        backgroundColor: bg,
        color: fg,
        padding: '1rem',
        whiteSpace: 'pre-wrap',
      }}
    >
      {children}
    </div>
  );
};
